import { InvoicePeriodType, PlanType, SubscriptionModel } from './account-subscription.model';

export const PlanTypeWeight = {
  [PlanType.FREE]: 0,
  [PlanType.BASIC]: 1,
  //Techdept an entry for starter had to be maintained for backwards compatabillity issues
  //Remove with tmp_rename_starter_to_basic (SHB-8838)
  [PlanType.STARTER]: 1,
  [PlanType.EARLY_ADOPTER]: 2,
  [PlanType.PREMIUM]: 3,
  [PlanType.ENTERPRISE]: 4,
};

export const hasAtleastSubscriptionPlan = (plan: PlanType, subscriptionModel: SubscriptionModel) => {
  if (!subscriptionModel) {
    return false;
  }
  return subscriptionModel.plan.weight >= PlanTypeWeight[plan];
};

export const hasAtMostSubscriptionPlan = (plan: PlanType, subscriptionModel: SubscriptionModel) => {
  if (!subscriptionModel) {
    return false;
  }
  return subscriptionModel.plan.weight <= PlanTypeWeight[plan];
};

export const hasExactlySubscriptionPlan = (plan: PlanType, subscriptionModel: SubscriptionModel) => {
  if (!subscriptionModel) {
    return false;
  }
  return subscriptionModel.plan.weight === PlanTypeWeight[plan];
};

export const getDisplayPrice = (
  currentSubscription: SubscriptionModel,
  selectedSubscription: SubscriptionModel,
  selectedInvoicePeriod?: InvoicePeriodType,
): string => {
  // Check if the current subscription matches the selected subscription
  const isSameSubscription = currentSubscription?.id === selectedSubscription.id;

  // Check if the current subscription is billed yearly using the enum
  const isCurrentYearlyBilling = currentSubscription?.invoice_period === InvoicePeriodType.YEAR;

  // Check if the user prefers yearly billing
  const prefersYearlyBilling = selectedInvoicePeriod === InvoicePeriodType.YEAR;

  // If the subscription matches and both billing periods (current and preferred) match
  if (isSameSubscription && isCurrentYearlyBilling === prefersYearlyBilling) {
    // Use the current subscription's display price
    return currentSubscription.display_price;
  }

  // If the user prefers yearly billing, use the yearly price, otherwise use the standard price
  return prefersYearlyBilling ? selectedSubscription.display_year_price : selectedSubscription.display_price;
};

// TODO this const is needed because backend had to store an unlimited quota as 9999999
// instead of something more sensible like -1 for backwards compatibility reasons.
// We need to account for that '9999999 === unlimited' quirk in some places.
export const UNLIMITED_QUOTA = 9999999;
